import React from 'react';

/**
 * Parses a pasted date string (MM/DD/YYYY, M/D/YYYY, MM-DD-YYYY) into YYYY-MM-DD format.
 * Returns null if the format is not recognized.
 */
function parsePastedDate(text: string): string | null {
  const trimmed = text.trim();

  // Match MM/DD/YYYY, M/D/YYYY, MM-DD-YYYY patterns
  const match = trimmed.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
  if (!match) return null;

  const month = match[1].padStart(2, '0');
  const day = match[2].padStart(2, '0');
  const year = match[3];

  // Basic validation
  const m = parseInt(month, 10);
  const d = parseInt(day, 10);
  const y = parseInt(year, 10);
  if (m < 1 || m > 12 || d < 1 || d > 31 || y < 1900 || y > 2100) return null;

  return `${year}-${month}-${day}`;
}

/**
 * onPaste handler for native date inputs. Intercepts pasted text in
 * MM/DD/YYYY format and converts it to YYYY-MM-DD for the input.
 */
export function handleDatePaste(
  e: React.ClipboardEvent<HTMLInputElement>,
  onChange: (value: string) => void,
): void {
  const text = e.clipboardData.getData('text');
  const iso = parsePastedDate(text);
  if (iso) {
    e.preventDefault();
    onChange(iso);
  }
  // If not recognized, let browser handle natively
}
